import React from 'react';
import { Link } from 'react-router-dom';

const TermsConditions = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold text-primary mb-8">Terms & Conditions</h1>
          <div className="mb-6">
            <p className="text-gray-600 mb-4"><strong>Effective Date:</strong> June 1, 2025</p>
            <p className="text-gray-700 mb-4">These Terms & Conditions govern your use of the Ongroom mobile app and services. Please read them carefully before proceeding.</p>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-700">By accessing or using Ongroom, you agree to be legally bound by these Terms and our Privacy Policy.</p>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. About Ongroom</h2>
            <p className="text-gray-700 mb-4">Ongroom is a digital platform that allows users to:</p>
            <ul className="list-disc pl-8 text-gray-700 space-y-2">
              <li>Book grooming and beauty services at nearby salons.</li>
              <li>Schedule home service appointments with gender-matched professionals.</li>
              <li>Choose between immediate or future time slots.</li>
            </ul>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Account Registration</h2>
            <ul className="list-disc pl-8 text-gray-700 space-y-2">
              <li>Users must register via Google login or mobile OTP.</li>
              <li>You must provide valid personal and address information.</li>
              <li>You are responsible for maintaining the confidentiality of your account.</li>
            </ul>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Service Conduct Rules</h2>
            <ul className="list-disc pl-8 text-gray-700 space-y-2">
              <li>At-home services are strictly gender-matched: male-to-male and female-to-female.</li>
              <li>Any misuse of the platform may result in account suspension.</li>
              <li>Service professionals have the right to refuse inappropriate conduct.</li>
            </ul>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Pricing & Payments</h2>
            <ul className="list-disc pl-8 text-gray-700 space-y-2">
              <li>Prices are displayed on the app and confirmed at booking.</li>
              <li>Payments can be made via UPI, cards, or the Ongroom Wallet.</li>
              <li>Offers, discounts, or coupons may be subject to terms.</li>
            </ul>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Cancellation & Refund</h2>
            <p className="text-gray-700">All cancellations and refunds are governed by our Refund Policy.</p>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Termination of Account</h2>
            <p className="text-gray-700">Ongroom reserves the right to suspend or terminate user accounts for violations of these terms, misuse, or inappropriate conduct.</p>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Limitation of Liability</h2>
            <p className="text-gray-700 mb-4">Ongroom is not liable for:</p>
            <ul className="list-disc pl-8 text-gray-700 space-y-2">
              <li>Personal injuries during service (users should ensure safety for home bookings).</li>
              <li>Delay or non-performance due to events beyond our control.</li>
              <li>Issues arising from third-party salons or staff.</li>
            </ul>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Intellectual Property</h2>
            <p className="text-gray-700">All content, logos, and visuals on the app are owned by Ongroom. You may not copy, use, or reproduce any content without written permission.</p>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Governing Law</h2>
            <p className="text-gray-700">These Terms are governed by the laws of India. Disputes will be handled in the jurisdiction of Mumbai, Maharashtra.</p>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Contact Information</h2>
            <p className="text-gray-700">Email: <a href="mailto:support@ongroom.com" className="text-primary hover:underline">support@ongroom.com</a></p>
          </div>

          <div className="mt-12 pt-6 border-t border-gray-200">
            <Link to="/" className="text-primary hover:underline flex items-center">
              <i className="ri-arrow-left-line mr-2"></i> Back to Home
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TermsConditions;